import React, { useState } from "react";
import {
  Box,
  Select,
  MenuItem,
  Typography,
} from "@mui/material";
import QuestionFileUpload from "../../QuestionFileUpload";
import { useTranslation } from "react-i18next";

const DropdownQuestion = ({
  q,
  sectionIndex,
  handleChange,
  error,
  isDisabled,
  handleFiles,
}) => {
  const { t } = useTranslation()
  const [answers, setAnswers] = useState((q.answers || []))
  
  return (
    <Box>
      <Select
        fullWidth
        size="small"
        displayEmpty
        value={answers?.[0]}
        onChange={(e) => {
          if (handleChange) {
            handleChange(sectionIndex, q, [e.target.value])
            setAnswers([e.target.value])
          }
        }}
        sx={{ mb: 1 }}
      >
        {q.options.map((opt, i) => (
          <MenuItem key={i}  value={opt?.id || `${opt.option}_${i}`}>
            {opt.option || t("questionnaire.form.optionWithNo", { number: i + 1 })}
          </MenuItem>
        ))}
      </Select>

      <QuestionFileUpload
        q={q}
        sectionIndex={sectionIndex}
        isDisabled={isDisabled}
        handleFiles={handleFiles}
      />

      {error && (
        <Typography variant="body2" color="error" sx={{ mt: 1 }}>
          {error}
        </Typography>
      )}
    </Box>
  );
};

export default DropdownQuestion;
